import { FC, PropsWithChildren } from "react";
import { ThemedHeader } from "./ThemedHeader";
import { Footer } from "./Footer";
import { useConsistentClient } from "@/premium/hooks/consistentClient";
import "./ContentContainer.scss";

export const ContentContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  useConsistentClient();

  return (
    <>
      <div className="premium-content-container">
        <ThemedHeader />
        {children}
      </div>
      <Footer />
    </>
  );
};
